module.exports = __webpack_public_path__ + "img/ring_y_e_0_0@3x.d6b9dda0.png";